<div class="modal is-active has-text-centered">
    <div class="modal-background"></div>
    <div class="modal-card" style="min-width: 600px; background-color: white; border-radius: 1em;">
      <header class="modal-card-head" style="background: none;border-bottom: none; padding-bottom: 0;">
        <p class="modal-card-title" style="color: var(--frog-green2); font-weight: bold;">Your session has expired, please log in again</p>
      </header>
      <section class="modal-card-body" style="background: none;">
        <app-loginform></app-loginform> 
      </section>
    </div>
  </div>